import axios from "axios";
import { toast } from "react-toastify";
import { FAQ_INFO_ERROR, GET_FAQ_INFO } from "../types";

export const getFaqData = (e) => async (dispatch) => {
    // console.log('test')
  try {
    var data = new FormData();

    var config = {
      method: "get",
      headers: {},
      url: `${process.env.NEXT_PUBLIC_API_URL}/faq`,
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      dispatch({
        type: GET_FAQ_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: FAQ_INFO_ERROR,
      payload: error.response,
    });
  }
};
